import React, {useState, useEffect} from "react";
import Mainheader from "../components/MainHeader/Mainheader";
import {useLocation, useNavigate} from "react-router";
import Button from "react-bootstrap/Button";
import {
  checkIdPhonenumberApi,
  cityListApi,
  createPasswordApi,
  getDoctorListByPatintApi,
  signUpApi,
  verifyPrescriptionUniqueCodeApi,
} from "../services/apiService";
import {toast} from "react-toastify";
import ExclamationIcon from "../assets/images/exclamation.svg";
import cancelIcon from "../assets/images/cancel-btn.svg";
import Nopreview from "../assets/images/Nopreview.svg";
import Preview from "../assets/images/preview.svg";
import ExclamationVioletIcon from "../assets/images/exclamation-violet.svg";

const Register = () => {
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [passVisible, setPassVisible] = useState(false);
  const [createPassModalOpen, setCreatePassModalOpen] = useState(false);
  const [idConfirmModalOpen, setIdConfirmModalOpen] = useState(false);
  const [scanModalOpen, setScanModalOpen] = useState(false);
  const [userIDFromRes, setUserIDFromRes] = useState();
  const [doctorList, setDoctorList] = useState([]);
  const [popupBtnDis, setPopupBtnDis] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handlevarification = () => {
    // Perform login logic here
    navigate("/verification");
  };

  const [formDataSignup, setFormDataSignup] = useState({
    cell_phone: "",
    id_number: "",
  });

  const [formErrorsSignup, setFormErrorsSignup] = useState({
    cell_phone: "",
    id_number: "",
  });

  const [password, setPassword] = useState();
  const [username, setUsername] = useState();
  const [emailAddress, setEmailAddress] = useState();
  const [prescriptionUniqueCode, setPrescriptionUniqueCode] = useState();

  const handleChangeSignup = e => {
    const {name, value} = e.target;
    setFormDataSignup({...formDataSignup, [name]: value});
    setFormErrorsSignup({...formErrorsSignup, [name]: ""});
  };

  const validateFormSignup = () => {
    let isValid = true;
    const errors = {
      cell_phone: "",
      id_number: "",
    };

    if (formDataSignup.cell_phone === "") {
      errors.cell_phone = "Please enter your phone number";
      isValid = false;
    }

    if (formDataSignup.cell_phone && !/^\d{5,10}$/.test(formDataSignup.cell_phone)) {
      errors.cell_phone = "Phone number is not valid.";
      isValid = false;
    }

    if (formDataSignup.id_number === "") {
      errors.id_number = "Please enter id number.";
      isValid = false;
    }

    if (formDataSignup.id_number && !/^\d{9}$/.test(formDataSignup.id_number)) {
      errors.id_number = "Invalid Id Number. It must be exactly 9 digits.";
      isValid = false;
    }

    setFormErrorsSignup(errors);
    return isValid;
  };

  const getDoctorListByPatient = async () => {
    try {
      const fd = new FormData();
      fd.append("id_number", formDataSignup.id_number);
      let apiRes = await getDoctorListByPatintApi(fd);
      let responseData = apiRes;

      if (responseData.data.res == false) {
        toast.error(responseData.data.msg, {autoClose: 1500});
      } else {
        setDoctorList(responseData.data.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const handleSignup = async e => {
    try {
      e.preventDefault();
      if (validateFormSignup()) {
        setIsSubmitting(true);
        let apiRes = await checkIdPhonenumberApi(formDataSignup);
        let responseData = apiRes;

        if (responseData.data.res == false) {
          toast.error(responseData.data.msg, {autoClose: 1500});
        } else {
          let tempSessionValue = {idNumber: formDataSignup.id_number, phoneNumber: formDataSignup.cell_phone};
          if (responseData.data.data === "both") {
            setCreatePassModalOpen(true);
            setUserIDFromRes(responseData.data.id || "");
          } else if (responseData.data.data === "phone_number") {
            setIdConfirmModalOpen(true);
          } else if (responseData.data.data === "id_number") {
            setScanModalOpen(true);
            getDoctorListByPatient();
            // navigate("/register/new");
          } else if (responseData.data.data === "new") {
            sessionStorage.setItem("doctolikTempNumberAndID", JSON.stringify(tempSessionValue));
            navigate("/register/new");
          }
          // navigate("/verification", {state: {id: responseData.data.data.id, from: location?.state?.from}}); idConfirmModalOpen
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCreatePassowrd = async () => {
    if (!username) {
      toast.warning("Please enter username.", {autoClose: 1500});
      return;
    } else if (emailAddress && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,3}$/.test(emailAddress)) {
      toast.warning("Email address is invalid.", {autoClose: 1500});
      return;
    } else if (!password) {
      toast.warning("Please enter password.", {autoClose: 1500});
      return;
    } else if (password && !/(?=^.{8,}$)(?=.*\d)(?=.*[!@#$%^&*]+)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(password)) {
      toast.warning(
        "Password must be at least 8 characters long, must contain at least one digit, one special character, one uppercase letter, one lowercase letter.",
        {autoClose: 2500}
      );
    } else {
      setPopupBtnDis(true);
      try {
        const fd = new FormData();
        fd.append("id_number", formDataSignup?.id_number);
        fd.append("cell_phone", formDataSignup?.cell_phone);
        fd.append("password", password || "");
        fd.append("email", emailAddress || "");
        fd.append("username", username || "");
        fd.append("flag", "0");

        let response = await createPasswordApi(fd);
        if (response) {
          if (response.data.res === true) {
            setCreatePassModalOpen(false);
            let tempSessionValue = {
              idNumber: formDataSignup.id_number,
              phoneNumber: formDataSignup.cell_phone,
              password: password,
              emailAddress: emailAddress,
              username: username,
            };
            sessionStorage.setItem("doctolikTempNumberAndID", JSON.stringify(tempSessionValue));
            navigate("/verification", {state: {id: userIDFromRes, from: location?.state?.from}});
          } else {
            toast.error(response.data.msg, {autoClose: 1500});
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setPopupBtnDis(false);
      }
    }
  };

  const handleCorrectIdClick = async () => {
    let tempSessionValue = {idNumber: formDataSignup.id_number, phoneNumber: formDataSignup.cell_phone};
    sessionStorage.setItem("doctolikTempNumberAndID", JSON.stringify(tempSessionValue));
    navigate("/register/new");
  };

  const handleScanBarcode = async () => {
    if (!prescriptionUniqueCode) {
      toast.warning("Please enter code to verify.", {autoClose: 1500});
    } else {
      try {
        setPopupBtnDis(true);
        const fd = new FormData();
        fd.append("id_number", formDataSignup.id_number);
        fd.append("unique_id", prescriptionUniqueCode || "");
        let response = await verifyPrescriptionUniqueCodeApi(fd);
        if (response) {
          if (response.data.res === true) {
            setUserIDFromRes(response.data.patient_id || "");
            let tempSessionValue = {idNumber: formDataSignup.id_number, phoneNumber: formDataSignup.cell_phone};
            sessionStorage.setItem("doctolikTempNumberAndID", JSON.stringify(tempSessionValue));
            setScanModalOpen(false);
            setCreatePassModalOpen(true);
            toast.success(response.data.msg || "Code verified successfully.", {autoClose: 1500});
          } else {
            toast.error(response.data.msg, {autoClose: 1500});
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
      } finally {
        setPopupBtnDis(false);
      }
    }
  };

  const daysarray = [];
  for (let i = 1; i <= 31; i++) {
    daysarray.push(i);
  }

  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 100;
  const years = [];

  for (let year = startYear; year <= currentYear; year++) {
    years.push(year);
  }

  const handleKeyPress = e => {
    const charCode = e.charCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  useEffect(() => {
    let value = JSON.parse(localStorage.getItem("doctolikLoginInfo")); //JSON.parse(secureLocalStorage.getItem('loginInfo'));
    if (value != undefined) {
      navigate("/");
    }
    sessionStorage.removeItem("doctolikTempNumberAndID");
  }, []);

  return (
    <div className="Main">
      <Mainheader />
      <div className="Fullbody">
        <div className="RegBox">
          <h3>Register</h3>
          <h4>Sign Up for free</h4>
          <h5>Enter your information to continue.</h5>

          {successMessage && <div className="success-message">{successMessage}</div>}
          {errorMessage && <div className="error">{errorMessage}</div>}

          <form className="login-form" onSubmit={handleSignup}>
            <div className="input-group">
              <input
                type="tel"
                placeholder="Phone Number"
                className={`telInput ${formErrorsSignup.cell_phone ? "inputHaveError" : ""}`}
                name="cell_phone"
                value={formDataSignup.cell_phone}
                onChange={handleChangeSignup}
                onKeyPress={handleKeyPress}
                inputMode="numeric"
                maxLength="10"
              />
              {formErrorsSignup.cell_phone && (
                <span className="vaidationError">
                  <img className="exclamationIcon" src={ExclamationIcon} /> {formErrorsSignup.cell_phone}
                </span>
              )}
            </div>
            <label className="labelTxt">A code will be sent to you on this number to validate your account.</label>

            <div className="input-group">
              <input
                type="number"
                placeholder="Id Number"
                className={`telInput ${formErrorsSignup.id_number ? "inputHaveError" : ""}`}
                name="id_number"
                value={formDataSignup.id_number}
                onChange={handleChangeSignup}
              />
              {formErrorsSignup.id_number && (
                <span className="vaidationError">
                  <img className="exclamationIcon" src={ExclamationIcon} />
                  {formErrorsSignup.id_number}
                </span>
              )}
            </div>
            <label className="labelTxt">This number is the 9 digits visible on your national ID card.</label>
            {isSubmitting ? (
              <Button className="login-button" variant="primary" type="submit" disabled>
                Please wait...
              </Button>
            ) : (
              <Button className="login-button" variant="primary" type="submit">
                Continue
              </Button>
            )}
          </form>
        </div>
      </div>
      {createPassModalOpen && (
        <div className="popup holidayPopup AddAppointmentModal createPassowrdPopup">
          <div className="popup-content">
            <button
              onClick={() => {
                setCreatePassModalOpen(false);
                setPassword("");
                setPassVisible(false);
              }}
              className="cancelBtn">
              <img src={cancelIcon} alt="" />
            </button>
            <div className="addNursePopup addAppointment">
              <h2 className="nurseHdn">Create Password</h2>
              <div className="patientAddBox">
                <ul className="addPatientList">
                  <li>
                    <label>Username</label>
                    <input type={"text"} autoComplete="new-password" placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} />
                  </li>
                  <li>
                    <label>Email Address</label>
                    <input
                      type={"text"}
                      autoComplete="new-password"
                      placeholder="Email address"
                      value={emailAddress}
                      onChange={e => setEmailAddress(e.target.value)}
                    />
                    <label className="labelTxt2">Email address is not mandatory.</label>
                  </li>
                  <li>
                    <label>Password</label>
                    <input
                      type={passVisible ? "text" : "password"}
                      autoComplete="new-password"
                      placeholder="Password"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                    />
                    <span className="password-icon" onClick={() => setPassVisible(!passVisible)}>
                      <img src={passVisible ? Nopreview : Preview} alt="Toggle Password Visibility" />
                    </span>
                  </li>
                  <li>
                    <button disabled={popupBtnDis} onClick={() => handleCreatePassowrd()}>
                      {popupBtnDis ? "Please wait..." : "Continue"}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
      {idConfirmModalOpen && (
        <div className="popup holidayPopup AddAppointmentModal createPassowrdPopup">
          <div className="popup-content">
            <button
              onClick={() => {
                setIdConfirmModalOpen(false);
              }}
              className="cancelBtn">
              <img src={cancelIcon} alt="" />
            </button>
            <div className="addNursePopup addAppointment">
              <h2 className="nurseHdn">ID Confirmation</h2>
              <div className="patientAddBox">
                <ul className="addPatientList">
                  <li>
                    <p>Your phone number is linked to a doctolik profile already but not to this ID number.</p> <br />
                    <p>Can you confirm that the ID number you introduced is correct.</p> <br />
                    <span className="IdNumberText">{formDataSignup.id_number}</span>
                  </li>
                  <li>
                    <button onClick={() => handleCorrectIdClick()}>ID is correct</button>
                    <button onClick={() => setIdConfirmModalOpen(false)} className="editIdBtn">
                      Edit the ID
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
      {scanModalOpen && (
        <div className="popup holidayPopup AddAppointmentModal createPassowrdPopup">
          <div className="popup-content">
            <button
              onClick={() => {
                setScanModalOpen(false);
                setPrescriptionUniqueCode("");
              }}
              className="cancelBtn">
              <img src={cancelIcon} alt="" />
            </button>
            <div className="addNursePopup addAppointment">
              <h2 className="nurseHdn">Unique Code Verification</h2>
              <div className="patientAddBox">
                <ul className="addPatientList">
                  <li>
                    <p>
                      Your ID number is used in some profile but with an other number, to connect to your profile please scan the bar code visible on your
                      prescription and enter the prescription unique code from{" "}
                      {doctorList?.length > 0 ? `Dr. ${doctorList[0]?.first_name} ${doctorList[0]?.last_name} ` : null}
                      <span className="tooltip-container">
                        <img className="exclamationIcon" src={ExclamationVioletIcon} alt="Exclamation Icon" />
                        <div className="tooltip">
                          <ul>
                            {doctorList?.map((item, index) => (
                              <li key={index}>{`Dr. ${item?.first_name} ${item?.last_name} `}</li>
                            ))}
                          </ul>
                        </div>
                      </span>
                      {/* <img className="exclamationIcon" src={ExclamationVioletIcon} /> */}
                    </p>{" "}
                    <br />
                  </li>
                  <li>
                    <label>Enter Prescription unique code</label>
                    <input
                      type={"text"}
                      placeholder="Enter Prescription unique code here..."
                      value={prescriptionUniqueCode}
                      onChange={e => setPrescriptionUniqueCode(e.target.value)}
                    />
                  </li>
                  <li>
                    <button disabled={popupBtnDis} onClick={() => handleScanBarcode()}>
                      {popupBtnDis ? "Please wait..." : "Continue"}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Register;
